import { PromptModal } from '@/components'
import type { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'
import type { EventFormValues } from './event-form-fields'
import { EventFormFields, validateEventForm } from './event-form-fields'

interface Props {
  initialValues: EventFormValues
  /** Defaults to the edit wording; pass the create wording when adding one. */
  title?: string
  description?: string

  onSubmit: PromptResolve<EventFormValues | null>
}

export const EditEventPrompt: React.FC<Props> = ({
  initialValues,
  title,
  description,
  onSubmit,
}) => {
  const translations = useTranslate({
    title: 'events.edit-event',
    save: 'common.save',
  })

  const [values, setValues] = useState<EventFormValues>(initialValues)

  return (
    <PromptModal
      title={title ?? translations.title}
      submitText={translations.save}
      submitDisabled={validateEventForm(values) !== null}
      className="w-[720px]"
      cancelOnEscape
      onCancel={() => onSubmit(null)}
      onSubmit={() => onSubmit(values)}
    >
      {!!description && (
        <p className="mt-0 mb-4 text-sm text-stone-500">{description}</p>
      )}

      <EventFormFields values={values} onChange={setValues} />
    </PromptModal>
  )
}
